import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { Provincia } from './Provincia';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { ComunidadAutonoma } from '../ComunidadesAutonomas/ComunidadAutonoma';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IProvinciaNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IProvinciaNewState {
    open: boolean;
    openErroDialog: boolean;
    hasErrors: boolean;
    errorMessage: string;
    comunidadesAutonomas: ComunidadAutonoma[];
}

export default class ProvinciaNew extends React.Component<IProvinciaNewProps, IProvinciaNewState> {
    _provincia: Provincia = new Provincia();
    
    public constructor(props: IProvinciaNewProps) {
        super(props);

        this.state = {
            open: false,
            openErroDialog: false,
            hasErrors: false,
            errorMessage: '',
            comunidadesAutonomas: []
        }
    }

    componentDidMount(): void {
        this.GetComunidadesAutonomas();
    }

    componentWillReceiveProps(nextProps: Readonly<IProvinciaNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Nueva provincia
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Código' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._provincia.codigo = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._provincia.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione una comunidad autónoma</InputLabel>
                                <Select label="Seleccione una comunidad autónoma" labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._provincia.comunidadAutonoma = event.target.value;
                                }}>
                                    {
                                        this.state.comunidadesAutonomas.map((value: ComunidadAutonoma, index: number) => {
                                            return (
                                                <MenuItem value={value.name}>
                                                    {
                                                        value.name
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private GetComunidadesAutonomas(): void {
        let url = `${Common.END_POINT}/masters/comunidadesautonomas`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    comunidadesAutonomas: response,
                    hasErrors: false
                }
            );
        })
    }

    private Save() {
        if(this._provincia.nombre == '' || this._provincia.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/provincias`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._provincia),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._provincia = new Provincia();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            this._provincia = new Provincia();
        });
    }
}